import React, {Component} from 'react'
import {Button} from 'antd';
import {Link} from 'react-router';

class SystemButtonAccount extends Component {
  handleClick(system) {
    this.props.onSetSystem(system)
  }

  render() {
    const {system} = this.props
    const to = `/systems/${system.ID}/users`
    return <Link to={to} onClick={() => this.handleClick(system)}>
      <Button type="primary" ghost="ghost" size="small">
        Account
      </Button>
    </Link>
  }
}

export default SystemButtonAccount;



// WEBPACK FOOTER //
// ./src/components/SystemButtonAccount.js